import { z } from 'zod';
import { SMTPCredentialSchema } from './SMTPCredential';
import { TextractCredentialSchema } from './TextractCredential';
export var AWSCredentialSchema = z.object({
    smtp: SMTPCredentialSchema.optional(),
    textract: TextractCredentialSchema.optional()
});
